import { render, staticRenderFns } from "./AdminStageTrans.vue?vue&type=template&id=18dab186&"
import script from "./AdminStageTrans.vue?vue&type=script&lang=js&"
export * from "./AdminStageTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports